<template>
    <div class="panel-service">
        <div class="index-container">
            <div class="index-title-group">
                <div class="index-title"><div>服务目标</div></div>
                <div class="index-title-sub">让制造企业在最短的时间，最低的成本，最小的风险，快速获益</div>
            </div>
            <div class="service-body">
                <div class="service-item">
                    <div class="service-icon icon1"/>
                    <div class="service-title">数治经营</div>
                    <div class="service-content">减少人为干预，即便人为操作，可由数据分析其真实性</div>
                </div>
                <div class="service-item">
                    <div class="service-icon icon2"/>
                    <div class="service-title">提效协同</div>
                    <div class="service-content">信息全面数字化，信息流转快速、通知传达及时，全域提效大协同</div>
                </div>
                <div class="service-item">
                    <div class="service-icon icon3"/>
                    <div class="service-title">数据真实</div>
                    <div class="service-content">数据实时上传和更新，保证数据统一存储，统一维护</div>
                </div>
                <div class="service-item">
                    <div class="service-icon icon4"/>
                    <div class="service-title">数据融合</div>
                    <div class="service-content">打破信息孤岛、融合全公司各业务环节数据，统筹分析</div>
                </div>
                <div class="service-item">
                    <div class="service-icon icon5"/>
                    <div class="service-title">数据可视化</div>
                    <div class="service-content">管理驾驶舱，对内各个岗位可实时查看数据，对外提供大数据展示，提升企业形象</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
name: "service"
}
</script>

<style scoped>
.panel-service {
    background-color: #FAFCFF;
    padding: 65px 0 45px;
}

.service-body {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
}

.service-body .service-item {
    padding: 45px 20px 0;
    height: 266px;
    width: 299px;
    background-color: #FFFFFF;
    box-shadow: 0 4px 8px 4px rgba(0, 0, 0, 0.02);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.service-body .service-icon {
    height: 46px;
    width: 100%;
}

.service-body .service-icon.icon1 {
    background: url("../../resource/img/index/s-1.png") center center no-repeat;
}
.service-body .service-icon.icon2 {
    background: url("../../resource/img/index/s-2.png") center center no-repeat;
}
.service-body .service-icon.icon3 {
    background: url("../../resource/img/index/s-3.png") center center no-repeat;
}
.service-body .service-icon.icon4 {
    background: url("../../resource/img/index/s-4.png") center center no-repeat;
}
.service-body .service-icon.icon5 {
    background: url("../../resource/img/index/s-5.png") center center no-repeat;
}

.service-body .service-title {
    font-family: "PingFang SC-Bold", "Source Han Sans CN", sans-serif;
    font-size: 24px;
    color: #141416;
    font-weight: 500;
    margin-top: 15px;
}

.service-body .service-content {
    font-size: 18px;
    color: #545454;
    margin-top: 16px;
    height: 40%;
    text-align: center;
}

.service-body .service-item:hover {
    background-color: #2844F7;
}

.service-body .service-item:hover .service-title,
.service-body .service-item:hover .service-content {
    color: #FFFFFF;
}

.service-body .service-item:hover .service-icon.icon1 {
    background: url("../../resource/img/index/s-6.png") center center no-repeat;
}
.service-body .service-item:hover .service-icon.icon2 {
    background: url("../../resource/img/index/s-7.png") center center no-repeat;
}
.service-body .service-item:hover .service-icon.icon3 {
    background: url("../../resource/img/index/s-8.png") center center no-repeat;
}
.service-body .service-item:hover .service-icon.icon4 {
    background: url("../../resource/img/index/s-9.png") center center no-repeat;
}
.service-body .service-item:hover .service-icon.icon5 {
    background: url("../../resource/img/index/s-10.png") center center no-repeat;
}
</style>
